"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.grayscale = exports.format = exports.quality = exports.progressive = exports.crop = exports.resize = void 0;
var MAX_WIDTH = 3000;
var MAX_HEIGHT = 3000;
function resize(width, height) {
    if (width === void 0) { width = null; }
    if (height === void 0) { height = null; }
    if (width == null && height === null) {
        throw new Error('At least one function argument has to be non-null');
    }
    var safeWidth = Math.min(width || MAX_WIDTH, MAX_WIDTH);
    var safeHeight = Math.min(height || MAX_HEIGHT, MAX_HEIGHT);
    if (width === null) {
        return "/resize/x" + safeHeight + "/";
    }
    if (height === null) {
        return "/resize/" + safeWidth + "/";
    }
    return "/resize/" + safeWidth + "x" + safeHeight + "/";
}
exports.resize = resize;
function crop(width, height) {
    var safeWidth = Math.min(width, MAX_WIDTH);
    var safeHeight = Math.min(height, MAX_HEIGHT);
    return "/crop/" + safeWidth + "x" + safeHeight + "/";
}
exports.crop = crop;
function progressive() {
    return "/progressive/yes/";
}
exports.progressive = progressive;
function quality(quality) {
    if (quality === void 0) { quality = 'smart'; }
    return "/quality/" + quality + "/";
}
exports.quality = quality;
function format(format) {
    return "/format/" + format + "/";
}
exports.format = format;
function grayscale() {
    return '/grayscale/';
}
exports.grayscale = grayscale;
//# sourceMappingURL=effects.js.map